// eslint-disable-next-line import/no-unassigned-import
import './text-encoding-polyfill';
const decoder = new TextDecoder('utf-8');
export function decode(bytes) {
    return decoder.decode(bytes);
}
const encoder = new TextEncoder();
export function encode(str) {
    return encoder.encode(str);
}
//# sourceMappingURL=utf8.browser.js.map